import { GET, POST, PUT } from '../request'

export const getLead = id => GET('/api/agora/marketing/feedback', { id })

export const getCRM = centro =>
  GET('/api/agora/marketing/feedback/list/CRM', { centro })

export const getOpenLeads = () => GET('/api/agora/marketing/feedback/list/open')

export const getFeedbackListYear = periodo =>
  GET(`/api/agora/marketing/feedback/list/year`, { periodo })

export const getPruebas = ({ fecha, centro }) =>
  GET('/api/agora/marketing/feedback/list/pruebas', { fecha, centro })

export const verificarLead = ({ emails, telefonos }) =>
  GET('/api/agora/marketing/feedback/verificar-lead', {
    emails,
    telefonos
  })

export const crearLead = ({
  contacto,
  contactado,
  nombreContacto,
  nombreAlumno,
  centroEstudios,
  asignaturas,
  tipologiaAcademica,
  curso,
  objetivos,
  comoConoce,
  formaContacto,
  centro,
  codigoPostal,
  leadStatus,
  fechaLead,
  horaLead,
  centroPrueba,
  fechaPrueba,
  horaPrueba,
  asignaturaPrueba,
  profesorPrueba,
  causaPerdido,
  fechaContacto,
  observaciones,
  pais,
  telefonos,
  emails
}) =>
  POST(
    '/api/agora/marketing/feedback',
    {},
    {
      personaContacto: contacto,
      contactado,
      nombreContacto,
      nombreAlumno,
      centroEstudios,
      asignaturaIds: asignaturas,
      tipologiaAcademica,
      curso,
      objetivos,
      comoConoce,
      formaContacto,
      centro,
      codigoPostal,
      leadStatus,
      fechaLead,
      horaLead,
      centroPrueba,
      fechaPrueba,
      horaPrueba,
      asignaturaPrueba,
      profesorPrueba,
      causaPerdido,
      fechaContacto,
      observaciones,
      pais,
      telefonos,
      emails
    }
  )

export const updateLead = ({
  id,
  contacto,
  nombreContacto,
  nombreAlumno,
  centroEstudios,
  asignaturas,
  tipologiaAcademica,
  formaContacto,
  curso,
  objetivos,
  comoConoce,
  centro,
  telefonoEntrante,
  codigoPostal,
  pais,
  telefonos,
  emails
}) =>
  PUT(
    '/api/agora/marketing/feedback',
    {},
    {
      id,
      contacto,
      nombreContacto,
      nombreAlumno,
      centroEstudios,
      asignaturas,
      tipologiaAcademica,
      formaContacto,
      curso,
      objetivos,
      comoConoce,
      centro,
      telefonoEntrante,
      codigoPostal,
      pais,
      telefonos,
      emails
    }
  )

export const addContacto = ({
  id,
  leadStatus,
  contactado,
  formaContactoLead,
  fechaLead,
  horaLead,
  centroPrueba,
  fechaPrueba,
  horaPrueba,
  asignaturaPrueba,
  profesorPrueba,
  fechaLeadCualificado,
  horaLeadCualificado,
  presupuestoLeadCualificado,
  formaContactoLeadCualificado,
  fechaIncorporacionLeadCualificado,
  causaPerdido,
  causaNoValido,
  alumnoCaptado,
  centroContacto,
  observaciones
}) => {
  if (leadStatus === 'LEAD') {
    return PUT(
      '/api/agora/marketing/feedback/nuevo-contacto',
      {},
      {
        id,
        leadStatus,
        contactado,
        formaContactoLead,
        fechaLead,
        horaLead,
        centroContacto,
        observaciones
      }
    )
  }
  if (leadStatus === 'PRUEBA') {
    return PUT(
      '/api/agora/marketing/feedback/nuevo-contacto',
      {},
      {
        id,
        leadStatus,
        centroPrueba,
        fechaPrueba,
        horaPrueba,
        asignaturaPrueba,
        profesorPrueba,
        centroContacto,
        observaciones
      }
    )
  }
  if (leadStatus === 'LEAD_CUALIFICADO') {
    return PUT(
      '/api/agora/marketing/feedback/nuevo-contacto',
      {},
      {
        id,
        leadStatus,
        contactado,
        fechaLeadCualificado,
        horaLeadCualificado,
        presupuestoLeadCualificado,
        fechaIncorporacionLeadCualificado,
        formaContactoLeadCualificado,
        centroContacto,
        observaciones
      }
    )
  }
  if (leadStatus === 'CLIENTE_CAPTADO') {
    return PUT(
      '/api/agora/marketing/feedback/nuevo-contacto',
      {},
      {
        id,
        leadStatus,
        alumnoCaptado,
        centroContacto,
        observaciones
      }
    )
  }
  if (leadStatus === 'CLIENTE_PERDIDO') {
    return PUT(
      '/api/agora/marketing/feedback/nuevo-contacto',
      {},
      {
        id,
        leadStatus,
        contactado,
        causaPerdido,
        centroContacto,
        observaciones
      }
    )
  }
  if (leadStatus === 'LEAD_NO_VALIDO') {
    return PUT(
      '/api/agora/marketing/feedback/nuevo-contacto',
      {},
      {
        id,
        leadStatus,
        contactado,
        causaNoValido,
        centroContacto,
        observaciones
      }
    )
  }
  if (leadStatus === 'LEAD_DERIVADO') {
    return PUT(
      '/api/agora/marketing/feedback/nuevo-contacto',
      {},
      {
        id,
        leadStatus,
        contactado,
        centroContacto,
        observaciones
      }
    )
  } else return Promise.reject('Error en el estado del lead')
}

export const modificarPrueba = ({
  id,
  fecha,
  hora,
  asignatura,
  asistencia,
  profesor,
  confirmacion
}) =>
  PUT(
    '/api/agora/marketing/feedback/modificar-prueba',
    {},
    {
      id,
      fecha,
      hora,
      asignatura,
      asistencia,
      profesor,
      confirmacion
    }
  )

export const updateTelefonos = ({ id, telefonos }) =>
  PUT(
    '/api/agora/marketing/feedback/telefonos',
    {},
    {
      id,
      telefonos
    }
  )

export const updateEmails = ({ id, emails }) =>
  PUT(
    '/api/agora/marketing/feedback/emails',
    {},
    {
      id,
      emails
    }
  )
